import { ETimeSlot } from "src/app/domain/enum/time-slot";
import { Intervention } from "src/app/domain/intervention";
import { ECalendarType } from "./calendar-type.model";

export class CalendarModel {
    Type: ECalendarType;
    Data: Intervention; // Should be Intervention
    Date: Date; // Required date or planned date depending of the filter
    TimeSlot: ETimeSlot;
}